import { BaseOperationModel } from '../base-operation-model';

export class MicrosoftOfficeUnProtectResourcesModel extends BaseOperationModel {
  orgUnitId: string;
  forceOrgUnitIdOnExistingUsers: boolean;
}
